export const CREATE_CATALOG = 'CREATE_CATALOG'
export const UPDATE_CATALOG = 'UPDATE_CATALOG'
export const DELETE_CATALOG = 'DELETE_CATALOG'
export const SEARCH_CATALOG = 'SEARCH_CATALOG'
export const SET_CATALOG_SEARCH_CRITERIA = 'SET_CATALOG_SEARCH_CRITERIA'
export const SET_CATALOG_DETAILS = 'SET_CATALOG_DETAILS'
export const SET_PRINT_ORDER_DETAILS = 'SET_PRINT_ORDER_DETAILS'
